import styled from 'styled-components'

export const RichTextContainer = styled.div<{
  $checked: boolean
  $disabled?: boolean
}>`
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  text-decoration: ${({ $checked }) => ($checked ? 'line-through' : 'none')};
`

export default RichTextContainer
